module.exports = __webpack_public_path__ + "static/media/undraw_movie_night_93wl.bd90a236.svg";